import * as tslib_1 from "tslib";
import { workbenchApi } from "@cloudpivot/api";
import tipsItem from '@cloudpivot/application/src/components/pc/components/tipsItem.vue';
import { Component, Vue } from 'vue-property-decorator';
let noticeTips = class noticeTips extends Vue {
    constructor() {
        super(...arguments);
        this.messageType = 'STATION';
        this.notices = [];
        this.searchword = '';
        this.size = 10;
        this.page = 0;
        this.tab = 'MESSAGE'; //APP:应用，MODEL模型，FLOW：流程待办， MESSAGE：消息通知，ALL：所有
    }
    get isChinese() {
        return !(this.$i18n.locale && this.$i18n.locale === "en");
    }
    readAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workbenchApi.updateReadStateAll({});
            if (res.errcode === 0) {
                this.paltformSearch();
                // utils.Bus.$emit('NoticeListChange');
            }
        });
    }
    messageTypeChange(type) {
        this.messageType = type;
        this.paltformSearch();
    }
    paltformSearch() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workbenchApi.paltformSearch({
                searchword: '',
                size: this.size,
                page: this.page,
                tab: this.tab,
                messageType: this.messageType,
                readState: 'UNREADED'
            });
            if (res.errcode === 0) {
                this.notices = res.data.MESSAGE.content;
            }
        });
    }
    created() {
        this.paltformSearch();
    }
};
noticeTips = tslib_1.__decorate([
    Component({
        name: 'noticeTips',
        components: {
            tipsItem
        }
    })
], noticeTips);
export default noticeTips;
